import { render, staticRenderFns } from "./ReportTab.vue?vue&type=template&id=04a882ce&"
import script from "./ReportTab.vue?vue&type=script&lang=js&"
export * from "./ReportTab.vue?vue&type=script&lang=js&"
import style0 from "./ReportTab.vue?vue&type=style&index=0&id=04a882ce&prod&lang=sass&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports